import React from 'react';
import { useFamily } from '../../contexts/FamilyContext';

/**
 * Banner showing "Viewing content from: [Family]" for multi-family users.
 * Renders nothing for single-family users.
 */
function FamilyContextBanner() {
  const { isMultiFamily, activeFamily } = useFamily();

  if (!isMultiFamily || !activeFamily) return null;

  return (
    <div className="bg-white rounded-xl px-4 py-3 mb-4 flex items-center gap-3 border border-gray-100 shadow-sm">
      <span className="text-[13px] text-gray-500">Viewing content from:</span>
      <span className="inline-flex items-center gap-1.5 bg-[#F0F4E8] text-[#556B2F] text-[13px] font-semibold px-3 py-1 rounded-full border border-[#6B8E23]/30">
        <span>🏠</span>
        {activeFamily.name}
      </span>
      {activeFamily.member_count != null && (
        <span className="text-[12px] text-gray-400">
          {activeFamily.member_count} {activeFamily.member_count === 1 ? 'member' : 'members'}
        </span>
      )}
    </div>
  );
}

export default FamilyContextBanner;
